import { createReducer, on } from '@ngrx/store';

import * as actions from '@shared/base-search-bar/store/actions/search-bar.actions';
import { AutoCompleteTravelExtra } from '@shared/base-search-bar/entities/autocomplete-travel-extra';

export const initialState: AutoCompleteTravelExtra = {
  activities: [],
  destinations: [],
};

export const autocompleteExtraReducer = createReducer(
  initialState,
  on(actions.searchExtraByQuerySuccessAction, (state, { response }) => {
    return mapTravelExtraAutocomplete(response);
  }),
  on(
    actions.resetAutocomplete,
    () => initialState
  ),
);

function mapTravelExtraAutocomplete(response: AutoCompleteTravelExtra): AutoCompleteTravelExtra {
  const formatList = {
    activities: response.activities.filter(activity => !!activity?.activityName && !!activity?.id),
    destinations: response.destinations
      .filter(destination => !!destination?.cityCode && !!destination?.cityName && !!destination?.id)
  };
  return formatList;
}
